export default "__VITE_ASSET__sPb3QEDN__"